// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

// @ts-ignore
import styles from './Label.css';

/**
 * @type {any}
 */
const TestableLabel = testable(QA_MALT, 'label');

/**
 * @type import('.').LabelComponent
 */
const Label = ({ children, htmlFor, className, testId, ...props }) => (
  <TestableLabel
    htmlFor={htmlFor}
    className={classnames(className, styles.label)}
    testId={testId}
    {...props}
  >
    {children}
  </TestableLabel>
);

Label.propTypes = {
  /** content of the label */
  children: PropTypes.node.isRequired,
  /** set HTML for attribute */
  htmlFor: PropTypes.string,
  /** add custom classes to the label */
  className: PropTypes.string,
  /** define a testid for the label */
  testId: PropTypes.string,
};

Label.displayName = 'Label';

export default Label;
